import React from 'react';
import { Helmet } from 'react-helmet-async';
import Header from '../components/Header';
import SimpleFooter from '../components/SimpleFooter';

const PrivacyPolicy = () => {
  // Scroll to top when component mounts
  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="bg-primary min-h-screen">
      <Helmet>
        <title>Privacy Policy - Humaniti.ai</title>
        <meta name="description" content="Privacy Policy for Humaniti.ai - Learn how we protect and manage your data." />
        <link rel="canonical" href="https://humaniti.ai/privacy-policy" />
      </Helmet>
      
      <Header />
      <div className="container mx-auto px-4 md:px-6 pt-32 pb-20">
        <div className="max-w-3xl mx-auto bg-cardBg p-8 md:p-12 rounded-lg shadow-lg">
          <h1 className="text-3xl font-bold mb-12 text-center text-textColor">Privacy Policy</h1>
          
          <section className="mb-10">
            <h2 className="text-xl font-semibold mb-4 text-purple-500">Information We Collect</h2>
            <p className="text-lightText text-lg leading-relaxed">
              When you join our waitlist, we collect the following information:
            </p>
            <ul className="list-disc pl-8 text-lightText text-lg leading-relaxed mt-2">
              <li>Name</li>
              <li>Email address</li>
              <li>Company name</li>
              <li>Referral code (optional)</li>
              <li>Reason for interest in Humaniti.ai (optional but helps us tailor early access)</li>
            </ul>
          </section>
          
          <section className="mb-10">
            <h2 className="text-xl font-semibold mb-4 text-purple-500">How We Use Your Information</h2>
            <p className="text-lightText text-lg leading-relaxed">
              We use this information to:
            </p>
            <ul className="list-disc pl-8 text-lightText text-lg leading-relaxed mt-2">
              <li>Keep you informed about Humaniti.ai updates, availability, and relevant announcements.</li>
              <li>Understand interest and prioritize early access for relevant users.</li>
            </ul>
          </section>
          
          <section className="mb-10">
            <h2 className="text-xl font-semibold mb-4 text-purple-500">Data Protection & Your Rights</h2>
            <ul className="list-disc pl-8 text-lightText text-lg leading-relaxed">
              <li>Your data is never shared, sold, or used for third-party marketing.</li>
              <li>You can request to remove your information at any time by contacting us at <a href="mailto:support@humaniti.ai" className="text-purple-500 hover:underline">support@humaniti.ai</a>.</li>
            </ul>
          </section>
        </div>
      </div>
      <SimpleFooter />
    </div>
  );
};

export default PrivacyPolicy;
